var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"x-small":""},on:{"click":function($event){return _vm.copyAccountNumber()}}},[_vm._v("\n  mdi-content-copy\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }